var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('ProjectsSingleHeader'),_c('ProjectsSingleIntro'),_c('ProjectsSingleContent'),(_vm.project)?_c('ProjectsSingleMore'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }